module.exports = __webpack_public_path__ + "img/sfx.99685ce3.jpg";